import * as React from "react";

import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

const goalList = {
  "Learning Goals": [
    {
      Goal_Description: "Improving class averages to ___________",
      Measure_Unit: "Class average %",
      Evidence: "-",
      SortOrder: 201,
    },
    {
      Goal_Description:
        "______ no. of opportunities will be created for students to become independent logical thinkers",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "events, projects, activities organized",
      SortOrder: 202,
    },
    {
      Goal_Description:
        "______ no. of inter-disciplinary learning opportunities will be created for students",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "interdisciplinary lesson plans/assessments conducted",
      SortOrder: 203,
    },
    {
      Goal_Description:
        "______ no. of experiential learning opportunities will be created for students",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence:
        "lesson plans with experiential learning projects, actual project description, images",
      SortOrder: 204,
    },
    {
      Goal_Description:
        "_______ no. of problem solving opportunities will be created for students",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "events, projects, activities organized",
      SortOrder: 205,
    },
    {
      Goal_Description:
        "_______ no. of creative expression opportunities will be created for students",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "events, projects, activities organized",
      SortOrder: 206,
    },
    {
      Goal_Description:
        "______ no. of exhibiting leadership opportunities will be created for students ",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "events, projects, activities organized",
      SortOrder: 207,
    },
    {
      Goal_Description:
        "______ no. of symbiotic learning opportunities will be be created for students",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "events, projects, activities organized",
      SortOrder: 208,
    },
    {
      Goal_Description:
        "______ no. of design thinking opportunities will be created for students ",
      Measure_Unit: "No. of opportunities through the tier/term/year",
      Evidence: "events, projects, activities organized",
      SortOrder: 209,
    },
  ],
  "Teaching goals": [
    {
      Goal_Description:
        "______ no. of lesson plans where differentiated learning strategies were used",
      Measure_Unit: "No. of lesson plans ",
      Evidence: "lesson plans, execution photos",
      SortOrder: 301,
    },
    {
      Goal_Description:
        "______ no. of lesson plans where project based learning strategies were used",
      Measure_Unit: "No. of lesson plans ",
      Evidence: "lesson plans, execution photos",
      SortOrder: 302,
    },
    {
      Goal_Description:
        "______ no. of lesson plans where flipped classroom techniques were used",
      Measure_Unit: "No. of lesson plans ",
      Evidence: "lesson plans, execution photos",
      SortOrder: 303,
    },
    {
      Goal_Description:
        "______ no. of lesson plans where inquiry based learning was used",
      Measure_Unit: "No. of lesson plans ",
      Evidence: "lesson plans, execution photos",
      SortOrder: 304,
    },
    {
      Goal_Description:
        "______ no. of lesson plans where field visits were planned",
      Measure_Unit: "No. of lesson plans ",
      Evidence: "lesson plans, execution photos",
      SortOrder: 305,
    },
    {
      Goal_Description:
        "______ no. of lesson plans where thinking routines were followed",
      Measure_Unit: "No. of lesson plans ",
      Evidence: "lesson plans, execution photos",
      SortOrder: 306,
    },
  ],
  "Leadership goals": [
    {
      Goal_Description:
        "________no. of lesson observations and review sessions conducted per teacher",
      Measure_Unit: "no. of observations ",
      Evidence: "observation schedule, observation sheets",
      SortOrder: 401,
    },
    {
      Goal_Description:
        "________% of teachers exceeding their individual goals ",
      Measure_Unit: "% of teachers",
      Evidence: "teacher review documents",
      SortOrder: 402,
    },
    {
      Goal_Description:
        "Will minimize teacher errors on papers/lesson plans/assignments to _________ %",
      Measure_Unit: "% error",
      Evidence: "teacher review documents",
      SortOrder: 405,
    },
  ],
};

const GoalsLibrary = ({ goalSettingForm, onSelect }) => {
  const [open, setOpen] = React.useState(false);
  const [selectedGoalDescription, setSelectedGoalDescription] =
    React.useState("");
  const [selectedMeasurementUnit, setSelectedMeasurementUnit] =
    React.useState("");
  const [selectedGoalEvidence, setSelectedGoalEvidence] = React.useState("");

  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleChange = (event, goal) => {
    setSelectedGoalDescription(goal.Goal_Description);
    setSelectedMeasurementUnit(goal.Measure_Unit);
    setSelectedGoalEvidence(goal.Evidence);
    setSelectedIndex(goal.SortOrder);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    setSelectedGoalDescription("");
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const handleSave = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
    onSelect &&
      onSelect(
        selectedGoalDescription,
        selectedMeasurementUnit,
        selectedGoalEvidence
      );
    setOpen(false);
  };

  const renderSelectListGroup = (goalCategory) => {
    const items = goalList[goalCategory].map((goal, index) => {
      return (
        <ListItem key={index} sx={{ width: "100%", maxWidth: 600 }}>
          <ListItemButton
            selected={selectedIndex === goal.SortOrder}
            onClick={(event) => handleChange(event, goal)}
          >
            <ListItemIcon>
              <ArrowRightIcon />
            </ListItemIcon>
            <ListItemText
              primary={goal.Goal_Description}
              secondary={`${goal.Measure_Unit} (Evidence Accepted - ${goal.Evidence})`}
            />
          </ListItemButton>
        </ListItem>
      );
    });
    return [items];
  };

  return (
    <div>
      <Button
        onClick={handleClickOpen}
        disabled={goalSettingForm.goalSettingState === "REVIEWED"}
      >
        Select goal from library
      </Button>
      <Dialog
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Choose goal</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: "flex", flexWrap: "wrap" }}>
            {Object.keys(goalList)?.map((goalCategory, index) => {
              return (
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="index"
                  >
                    <Typography>{goalCategory}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List component="nav" aria-label="secondary mailbox folder">
                      {renderSelectListGroup(goalCategory, index)}
                    </List>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GoalsLibrary;
